import {type TranslationObject} from '@colonist/i18n'
import {createDivIn, createSpanIn} from '../ui_utils/DomUtils.ts'

export class UIReconnectingBackgroundView {
    private static connectionLostBackground: HTMLDivElement | undefined

    static show(text: TranslationObject) {
        if(this.connectionLostBackground != undefined) return

        const overlay = createDivIn(document.body, 'game-reconnecting-overlay')
        createDivIn(overlay, 'loading-spinner')
        createSpanIn(overlay, 'game-reconnecting-text', text)

        this.connectionLostBackground = overlay
    }

    static remove() {
        if(this.connectionLostBackground != undefined) this.connectionLostBackground.remove()
        this.connectionLostBackground = undefined
    }
}
